module.exports = __webpack_public_path__ + "img/fileDel.9311b462.png";